var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('report-graph',{attrs:{"chartData":_vm.chartData,"repositionSpeedDial":true}}),_c('report-table',{attrs:{"initialSortedColumns":['quickNote'],"headers":_vm.headers,"items":_vm.tableItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }